/* 
* 
* 路由菜单
* isMenu: true  表示是菜单
* auth: 权限，根据权限列表增加
* 
*/
const getRoutes = (routes)=>{
	let list = [];
	for(let i = 0; i < routes.length; i++){
		list = list.concat(routes[i].children);
	}
	return list;

};

export const menuLists =  [
    { path: '/goodsManage', name: 'goodsManage', title: '服务管理', icon: 'icon-nav_commodity', auth: 'product_all', isMenu: true, children: [
        { path: '/goodsManage/esGoodsManage', name: 'esGoodsManage', title: '企业服务管理', auth: 'product_es_list', isMenu: true, component: () =>import(`@/views/goodsManage/esGoodsManage/App.vue`) , meta: { navIndex: '/goodsManage/esGoodsManage' } },
        //商品管理-- 企业服务商品管理 -- 添加商品
        { path: '/goodsManage/addGoods', name: 'addGoods', title: '新增服务', auth: 'product_es_add', component: () =>import(`@/views/goodsManage/esGoodsManage/addGoods.vue`), meta: { navIndex: '/goodsManage/esGoodsManage' } },
    ]},
    // 系统设置
    { path: '/setting', name: 'setting', title: '系统设置', icon: 'icon-nav_set', auth: 'system_all', isMenu: true, children: [
        { path: '/setting/subAccount', name: 'subAccount', title: '子账号管理', auth: 'user_list', isMenu: true, component: () =>import(`@/views/setting/subAccount/App.vue`), meta: { navIndex: '/setting/subAccount' } },
        // 角色管理
        { path: '/setting/roles', name: 'roles', title: '角色管理', auth: 'role_list', isMenu: true, component: () =>import(`@/views/setting/roles/list.vue`), meta: { navIndex: '/setting/roles' } },
        { path: '/setting/editPwd', name: 'editPwd', title: '修改密码', auth: 'editPwd_list', isMenu: true, component: () =>import(`@/views/setting/editPwd/App.vue`), meta: { navIndex: '/setting/esGoodsManage' } },
        //  系统设置——商户信息开始
        { path: '/setting/merchant', name: 'merchant', title: '服务商信息', auth: 'info_all', isMenu: true, component: () =>import(`@/views/setting/merchant/merchantAll.vue`), meta: { navIndex: '/setting/merchant' }},
        { path: '/setting/merchant/merchantUpt', name: 'merchantUpt', title: '服务商信息编辑', auth: 'info_modify', component: () =>import(`@/views/setting/merchant/merchantUpt.vue`), meta: { navIndex: '/setting/merchant' } },
        { path: '/setting/merchant/merchantHistory', name: 'merchantHistory', title: '服务商信息历史修改记录', auth: 'info_history', component: () =>import(`@/views/setting/merchant/merchantHistory.vue`), meta: { navIndex: '/setting/merchant' } },
        { path: '/setting/merchant/checkRemark', name: 'checkRemark', title: '服务商驳回', auth: 'info_modify', component: () =>import(`@/views/setting/merchant/checkRemark.vue`), meta: { navIndex: '/setting/merchant' } },
        //  系统设置——商户信息结束
        { path: '/setting/business', name: 'business', title: '营业设置', auth: 'shop_all', isMenu: true, component: () =>import(`@/views/setting/business/businessList.vue`), meta: { navIndex: '/setting/business' } },
    ]}
];

export const routeList = [
    { path: '/', name: 'index', /* redirect: '/goodsManage/esGoodsManage', */ component: () => import(`@/views/index/App.vue`), children: [
        { path: '/standardPage', name: 'standardPage', auth: 'editPwd_list', title: '样式示例', component: () =>import(`@/views/404/standardPage.vue`) },
        // 商品管理
        ...getRoutes(menuLists)
    ]}
]

